import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { IGenre, IMedia, IPagination, EPeriod, ELanguage, ICategory } from '../interfaces';
import Axios, { AxiosResponse } from 'axios';
import config from '../config';
import Track from '../components/items/Track';
import Pagination from '../components/common/Pagination';
import { connect } from 'react-redux';
import Favorite from '../components/parts/Favorite';
import { transliterate } from '../utils/functions';
import i18n from '../config/i18next';
import Banner from '../components/parts/Banner';
import Helmet from 'react-helmet';

let russian = ["А", "Б", "В", "Г", "Д", "Е", "Ё", "Ж", "З", "И", "К", "Л", "М", "Н", "О", "П", "Р", "С", "Т", "У", "Ф", "Х", "Ц", "Ч", "Ш", "Щ", "Э", "Ю", "Я"];
let latin = ["A", "B", "C", "Ch", "D", "E", "F", "G", "G'", "H", "I", "J", "K", "L", "M", "N", "O", "O'", "P", "Q", "R", "S", "Sh", "T", "U", "V", "W", "X", "Y", "Z", "0-9"];

const CancelToken = Axios.CancelToken;
let cancel: any;

interface IState {
    categories: ICategory[],
    medias: IMedia[],
    isLoading: boolean,
    currentPage: number,
    totalPages: number,
    pages: IPagination,
    isPopularLoading: boolean,
    popularMedias: IMedia[],
    period: EPeriod,
    showMore: boolean

}

class ShowBusiness extends React.Component<any, IState> {
    private _isUnmounted: boolean = false;

    constructor(props: any) {
        super(props);

        this.state = {
            categories: [],
            medias: [],
            isLoading: true,
            currentPage: 1,
            totalPages: 1,
            pages: null,
            isPopularLoading: true,
            popularMedias: [],
            period: EPeriod.DAY,
            showMore: false

        };

        this.onPageChange = this.onPageChange.bind(this);
    }

    componentDidMount() {
        this.loadMedias();
        this.loadPopularMedias();

    }

    async loadPopularMedias() {
        let response: AxiosResponse = await Axios.get(`${config.site}/${i18n.language}/api/show-business/popular-list?filter=${this.state.period}`);

        let { data } = response;

        if (!this._isUnmounted)
            this.setState({
                popularMedias: data,
                isPopularLoading: false
            });
    }

    async loadMedias() {
        cancel && cancel();

        try {
            let response: AxiosResponse = await Axios.get(`${config.site}/${i18n.language}/api/show-business/list` + (this.state.pages ? (`?${this.state.pages.pageParam}=${this.state.currentPage}`) : ``), {
                cancelToken: new CancelToken(function executor(c) {
                    cancel = c;
                })
            });

            let { data } = response;

            let totalPages = response.data.pages.pageCount;

            if (!this._isUnmounted)
                this.setState({
                    medias: data.medias,
                    isLoading: false,
                    pages: data.pages,
                    totalPages: totalPages,
                    currentPage: totalPages > 0 ? this.state.currentPage : 1
                });
        } catch (err) {

        }

    }

    onChangePeriod(period: EPeriod) {
        this.setState({
            period,
            isPopularLoading: true
        }, this.loadPopularMedias);
    }

    componentWillUnmount() {
        this._isUnmounted = true;
    }

    onPageChange(page: number) {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });

        this.setState({
            currentPage: page,
            isLoading: true,
        }, async () => {
            await this.loadMedias();

        });
    }

    render() {
        return (
            <div className="i-body">
                <Helmet>
                    <title>{"Новости" + " | " + window.location.host.toUpperCase() + " - Медиа портал в TAS-IX"}</title>
                </Helmet>
                <div className="container login-page v-index">
                    <div className="wrapper">
                        <div className="row">
                            <div className="col-md-8 col-xs-12">
                                <ul className="submenu">
                                    <li className={"active"}><a>Новости</a></li>

                                </ul>
                                <div className="wrap">

                                    {this.state.isLoading && <div className="carousel-placeholder" />}
                                    {!this.state.isLoading && this.state.medias.length == 0 && <h5 className="text-center mt-20">Ничего не найдено</h5>}

                                    <div className="news_list">
                                        {!this.state.isLoading && this.state.medias.map((track: IMedia, index: number) => {
                                            return (
                                                <div key={index} className="news_box">
                                                    <div className="row">
                                                        <div className="col-md-4 col-sm-4 col-xs-12">
                                                            <div className="img">
                                                                <div className="date">{track.date}</div>
                                                                <img className="w-100" src={track.fullImage} alt={track.name}/>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-8 col-sm-8 col-xs-12">
                                                            <NavLink to={"/show-business/" + transliterate(track.name) + "/" + track.media_id} className="title">{track.name}</NavLink>
                                                            <div dangerouslySetInnerHTML={{__html: track.info.replace(/<[^>]*>?/gm, '').split(". ").shift() + "..."}}></div>
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                    {this.state.medias.length > 0 && <Pagination currentPage={this.state.currentPage} totalPages={this.state.totalPages} onChange={this.onPageChange} />}
                                </div>
                            </div>
                            <div className="col-md-4 col-xs-12">
                                <div className="right_side">
                                    <div className="widget">
                                        <div className="title mb-5px">Популярные статьи</div>
                                        <div className="rayting-box">
                                            <a onClick={() => {
                                                this.onChangePeriod(EPeriod.DAY);
                                            }} className={this.state.period == EPeriod.DAY ? "active" : ""}>День</a>
                                            <a onClick={() => {
                                                this.onChangePeriod(EPeriod.WEEK);
                                            }} className={this.state.period == EPeriod.WEEK ? "active" : ""}>Неделя</a>
                                            <a onClick={() => {
                                                this.onChangePeriod(EPeriod.MONTH);
                                            }} className={this.state.period == EPeriod.MONTH ? "active" : ""}>Месяц</a>
                                        </div>

                                        {this.state.isPopularLoading && <div className="carousel-placeholder" />}
                                        {!this.state.isPopularLoading && <ul className={"pop_n rayting-list " + (this.state.showMore ? 'scroll' : '')}>
                                            {/* <!--scroll class can be added to scroll--> */}
                                            {this.state.popularMedias.map((track: IMedia, index: number) => {
                                                if (!this.state.showMore && index > 10) return;

                                                return <li key={index}>
                                                    
                                                    <div className="name">
                                                        <NavLink to={"/clip/" + transliterate(track.name) + "/" + track.media_id}>
                                                            {track.name}
                                                        </NavLink>
                                                    </div>
                                                </li>
                                            })}
                                            {!this.state.isPopularLoading && this.state.popularMedias.length == 0 && <li className="text-center">Ничего не найдено</li>}
                                        </ul>}
                                        {!this.state.isPopularLoading && this.state.popularMedias.length > 0 && <div className="text-center">
                                            <a onClick={() => {
                                                this.setState({
                                                    showMore: !this.state.showMore
                                                });
                                            }}>{this.state.showMore ? "Показать меньше" : "Показать больше"}</a>
                                        </div>}
                                    </div>
                                    <Banner className="banner235" place={16}/>
                                    <Banner className="banner235" place={17}/>
                                    
                                </div>
                            </div>
                        </div>
                        <Banner className="banner235" place={18}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(undefined)(ShowBusiness);